const NATIVE_ASSET_BY_CHAIN: Record<string, string> = {
  ethereum: 'ETH',
  polygon: 'MATIC',
  bsc: 'BNB',
  akash: 'AKT',
  fet: 'FET',
  asi: 'FET',
  fetchhub: 'FET',
  bitcoin: 'BTC',
  tao: 'TAO',
  solana: 'SOL',
  sui: 'SUI',
};

const toFiniteNumber = (value: any, fallback: number) => {
  const parsed = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const getWalletChain = (wallet: any): string | undefined => {
  if (typeof wallet?.chain === 'string' && wallet.chain.trim()) {
    return wallet.chain.trim().toLowerCase();
  }
  if (typeof wallet?.blockchain === 'string' && wallet.blockchain.trim()) {
    return wallet.blockchain.trim().toLowerCase();
  }
  return undefined;
};

export const getNativeAssetIdForChain = (chain?: string): string => {
  if (!chain) return 'ONCHAIN';
  return NATIVE_ASSET_BY_CHAIN[chain] || chain.toUpperCase();
};

export const normalizeStoreOnchainAsset = (asset: any) => {
  const chain = getWalletChain(asset);
  const explicitAssetId = typeof asset?.assetId === 'string' && asset.assetId.trim()
    ? asset.assetId.trim().toUpperCase()
    : typeof asset?.symbol === 'string' && asset.symbol.trim()
      ? asset.symbol.trim().toUpperCase()
      : undefined;
  const assetId = explicitAssetId || getNativeAssetIdForChain(chain);
  const quantity = toFiniteNumber(asset?.quantity, 0);
  const parsedPrice = typeof asset?.price === 'number' ? asset.price : Number(asset?.price);
  const price = Number.isFinite(parsedPrice) ? parsedPrice : undefined;
  const parsedValue = typeof asset?.value === 'number' ? asset.value : Number(asset?.value);
  const value = Number.isFinite(parsedValue)
    ? parsedValue
    : typeof price === 'number'
      ? price * quantity
      : undefined;
  const walletId = asset?.walletId ?? asset?.id;
  const id = asset?.id ?? (walletId && assetId ? `${walletId}:${assetId}` : undefined);

  return {
    ...asset,
    id,
    walletId,
    chain: chain ?? asset?.chain ?? asset?.blockchain,
    blockchain: chain ?? asset?.blockchain ?? asset?.chain,
    assetId,
    quantity,
    ...(typeof price === 'number' ? { price } : {}),
    ...(typeof value === 'number' ? { value } : {}),
    sourceType: 'ONCHAIN',
    type: 'ONCHAIN',
  };
};

export const normalizeStoreOnchainAssets = (assets: any[]) => {
  if (!Array.isArray(assets)) return [];
  return assets.map((asset: any) => normalizeStoreOnchainAsset(asset));
};